import Speech from 'speak-tts'
const speech = new Speech()
export default speech 